import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import { tmsApi } from "../../api";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import {
  formatDateTime,
  getCarTypes,
  getCorporateClients,
  getCorporateClientsBySeviceCityIdAndTravelType,
  showAlert,
} from "../../Services/Shared.service";
import {
  createPackage,
  editPackageDetails,
  getPackage,
  getTaxGroupList,
} from "../../Services/Packages.service";
import { addMonths, startOfMonth } from "date-fns";
import { ArrowDown, ArrowUp } from "react-feather";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { CommonModal } from "../../AbstractElements";
import SharedDataContext from "../../_helper/SharedData";
import { getCorporateClient, getThirdPartyList } from "../../Services/CorporateClient.service";
import CustomAutoSuggest from "../../CommonElements/CustomAutoSuggest/index";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import {
  Box,
  Button,
  Drawer,
  Typography,
  unstable_composeClasses,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { getCorporateClientsListBySearch } from "../../Services/CorporateClient.service";
import {
  getPackagesRateListBySearch,
  getPackagesList,
  getPackagesListCorp,
  getPackagesListBySearch,
} from "../../Services/Packages.service";
import { getPackagesListExt } from "../../Services/ExternalThirdParty.service";
import closeIcon from "../../assets/images/tarrifManagement/closeIcon.svg";

function CreateEditPackageDrawerForm({ title, isOpen, setIsOpen, editId, fetchTableData }) {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      name: "",
      description: "",
      isActive: false,
      isKiosk: false,
      autoRollover: false,
      isAirportExpress: false,
      serviceType: "",
      city: "",
      carTypeDropdown: "",
      baseFareTax: "",
      serviceTax: "",
      corprateClient: "",
      terminal:"",
      isAirportBooking: false,
      applicableFromDate: new Date(),
      applicableToDate: addMonths(new Date(), 1),
      overallTax: null,
    },
  });

  const values = getValues();
  const { isDriverPayout, overallTax } = watch();

  const [carTypeData, setCarTypeData] = useState([]);
  const [corporateClientData, setCorporateClientData] = useState([]);
  const [thirdPartyData, setThirdPartyData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAdvanced, setIsAdvanced] = useState(false);
  const { mix_background_layout } = useContext(CustomizerContext);
  const [packageObj, setPackageObj] = useState({});
  const [selectedCorp, setSelectedCorp] = useState({});
  const [corpsPresent, setCorpsPresent] = useState(false);
  const [defaultOpt, setDefaultOpt] = useState({ "": "" });
  const [serviceCityId, setServiceId] = useState();
  const [serviceCity, setServiceCity] = useState([]);
  const [searchPack, setSearchPack] = useState(true);
  // const[corpList,setCorpList] = useState([]);
  // const[options,setOptions] = useState([]);
  const { cityData } = useContext(SharedDataContext);
  const [selectedOption, setSelectedOption] = useState();
  const [corpClientsPacks, setCorpClientsPack] = useState([]);
  // const [editId, setEditId] = useState();

  //existing flow for thirdparty
  // const[cityId,setCityId] = useState();
  const [editThirdParty, setEditThirdParty] = useState(false);
  const [selectedThirdParty, setSelectedThirdParty] = useState();
  const [thirdPartyPack, setThirdPartyPack] = useState();
  const [selectedThirdPack, setSelectedThirdPack] = useState();
  const [parentCorpClient, setParentCorpClient] = useState({});

  const [combinedTax, setCombinedTax] = useState([]);
  const terminals = [
    { value: "IGI-T3", label: "IGI-T3" },
    // { value: "IGI-T2", label: "IGI-T2" },
    { value: "IGI-T1", label: "IGI-T1" },
  ];
  useEffect(() => {
    getTaxGroupList().then((result) => {
      if (result.status == 200) {
        setCombinedTax(generateTaxCombinationsForSelectBox(result.data));
      }
    });
  }, []);

  function generateTaxCombinationsForSelectBox(taxData) {
    let basezero = taxData.filter((t) => t.taxRate === 0);
    let basenonzero = taxData.filter((t) => t.taxRate !== 0);
    console.log("Base Zero :", basezero);
    basezero.sort((a, b) => a.taxCategory.localeCompare(b.taxCategory));
    basenonzero.sort((a, b) => a.taxCategory.localeCompare(b.taxCategory));
    let combinations = [];
    combinations.push({
      label: `Base ${basenonzero[0].taxRate}% Service ${basenonzero[1].taxRate}%`,
      value: { baseTax: basenonzero[0], serviceTax: basenonzero[1] },
    });
    combinations.push({
      label: `Base ${basezero[0].taxRate}% Service ${basezero[1].taxRate}%`,
      value: { baseTax: basezero[0], serviceTax: basezero[1] },
    });
    return combinations;
  }

  useEffect(() => {
    getThirdPartyPackages(selectedThirdParty);
  }, [selectedThirdParty]);

  const getThirdPartyPackages = (selectedThirdParty) => {
    console.log(selectedThirdParty);
    if (selectedThirdParty) {
      let obj = {
        corporateId: selectedThirdParty.value.id,
      };
      console.log("corporateclient->packageforms", obj);
      getPackagesListCorp(obj).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data.list.map((element) => {
            return {
              value: element,
              label: element.name,
            };
          });
          setThirdPartyPack(data);
        }
      });
    }
  };

  //common function for getting package & 3rd parties options :
  //   const PackageThirdPartyOptionsSearch = async (inputValue) => {
  //     if (isThirdParty) {
  //       if (inputValue) {
  //         let obj = {
  //           key: inputValue,
  //           // serviceCityId:cityField?.value.id
  //         };
  //         return fetchThirdParty(obj).then((resp) => {
  //           if (resp.data.length > 0) {
  //             let data = resp.data.map((element) => {
  //               return {
  //                 value: element,
  //                 label: element?.address ? element.address : element,
  //               };
  //             });
  //             return data;
  //           }
  //           return [];
  //         });
  //       }
  //     } else {
  //     }
  //   };

  const handleSelectThirdParty = (selectedThirdParty) => {
    // setTitle("Edit Package")
    console.log("selected thirdParty", selectedThirdParty);
    setSelectedThirdParty(selectedThirdParty);
    setSearchPack(false);
    setEditThirdParty(true);
  };

  const filterCitiesById = (id) => {
    return cityData.find((city) => city.value.id === id);
  };

  const cityField = useController({
    name: "city",
    control,
    rules: {
      required: {
        value: true,
        message: "City is Required",
      },
    },
  }).field;

  const handleCitySelectChange = (data) => {
    // console.log("cityField value",data.value);
    cityField.onChange(data.value);
    carTypeField.onChange(null)
  };

  const corporateClientField = useController({
    name: "corporateClient",
    control,
    rules: {
      // required: {
      //     value:true ,
      //     message: "Corporate Client is Required",
      // },
    },
  }).field;

  const handleTerminalSelectChange = (data) => {
    setValue("terminal", data, { shouldValidate: true });
  };

  // const corporateClientTextField = useController({
  //     name:"corporateClient",
  //     control,
  //     required: {
  //         value: corpsPresent ? true:false,
  //         message: "Corporate Client is Required",
  //     },
  // }).field

  const handleCorporateClientSelectChange = (data) => {
    console.log("corporateClientField is ", data.value);
    corporateClientField.onChange(data.value);
  };

  const applicableToDateField = useController({
    name: "applicableToDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable To Date is Required",
      },
    },
  }).field;

  const ThirdPartyField = useController({
    name: "thirdPartydropdrow",
    control,
    rules: {
      // required: {
      //     value:isThirdParty,
      //     message:"Thirdparty required"
      // }
    },
  });


  const handleThirdPartyField = (data) => {
    ThirdPartyField.onChange(data);
  };

  const handleApplicableToDate = (data) => {
    applicableToDateField.onChange(data);
  };

  const applicableFromDateField = useController({
    name: "applicableFromDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable From Date is Required",
      },
    },
  }).field;

  const handleApplicableFromDate = (data) => {
    applicableFromDateField.onChange(data);
  };

  const carTypeField = useController({
    name: "carTypeDropdown",
    control,
    rules: {
      required: {
        value: true,
        message: "Car type is Required",
      },
      validate: (value) => {
        if (!value || !value.id) {
          return "Car type is Required";
        }
        return true;
      },
    },
  }).field;

  const handleCarTypeSelectChange = (data) => {
    carTypeField.onChange(data.value);
  };

  const isActiveField = useController({
    name: "isActive",
    control,
  }).field;

  const isKioskField = useController({
    name: "isKiosk",
    control,
  }).field;

  const autoRolloverField = useController({
    name: "autoRollover",
    control,
  }).field;

  const isAirportExpressField = useController({
    name: "isAirportExpress",
    control,
  }).field;

  const baseFareTaxField = useController({
    name: "baseFareTax",
    control,
    // rules: {
    //     required: {
    //         value: true,
    //         message: "Base Fare Tax is Required",
    //     },
    // },
  }).field;

  const terminalField = useController({
      name: "terminal",
      control,
      rules: {
        required: {
          value: false,
          message: "Terminal is Required",
        },
      },
    }).field;

  // useEffect(() => {
  //   setCorporateClientData([]);
  //   const serviceCityId = cityField.value?.id;
  //   if (!serviceCityId) {
  //     setCarTypeData([]);
  //     return;
  //   }
  //   let obj = {
  //     serviceCityId,
  //     travelType: isAirportExpressField.value ? "A2C" : "C2A",
  //   };
  //   getCorporateClientsBySeviceCityIdAndTravelType(obj).then((result) => {
  //     if (result.status == 200) {
  //       const data = result.data.list.map((element) => {
  //         return {
  //           value: element,
  //           label: element.companyName,
  //         };
  //       });
  //       setCorporateClientData(data);
  //     }
  //   });
  // }, [isAirportExpressField.value]);

  useEffect(() => {
    const serviceCityId = cityField.value?.id;
    if (!serviceCityId) {
      setCarTypeData([]);
      return;
    }
    let obj = {
      serviceCityId,
      travelType: isAirportExpressField.value ? "A2C" : "C2A",
    };
    getCarTypes(obj)
      .then((result) => {
        const data = result.data.map((element) => {
          return {
            label: element.name,
            value: element,
          };
        });
        setCarTypeData(data);
      })
      .catch((err) => {
        showAlert("error", "Unable to fetch Car details for selected City");
      });


    getCorporateClients().then((result) => {
      if (result.status == 200) {
        console.log("data list:",result.data);
        const filteredList = result.data.filter((item) => {
          return item.serviceCityId === serviceCityId; // filter by selected city
        });

        const data = filteredList.map((element) => ({
          value: element,
          label: element.companyName,
        }));
        setCorporateClientData(data);
        console.log("Corprate client options", data);
      }
    });
    // if (isThirdParty) {
    //   getThirdPartyList(serviceCityId).then((resp) => {
    //     if (resp.status == 200) {
    //       const thirdParties = resp.data.list.map((element) => {
    //         return {
    //           value: element,
    //           label: element.companyName,
    //         };
    //       });
    //       setThirdPartyData(thirdParties);
    //       console.log("thirdPartyData is :====>", thirdPartyData);
    //     }
    //   });
    // }
  }, [cityField.value]);

  useEffect(() => {
    if (editId && isOpen) {
      getPackage({ packageId: editId })
        .then((result) => {
          setPackageObj(result.data);
          const serviceCity = cityData.find((element) => {
            return element?.value?.id === result.data?.serviceCityId;
          });
          reset({
            name: result.data?.name ? result.data?.name : "",
            description: result.data?.description
              ? result.data?.description
              : "",
            isActive: result.data?.isActive ? result.data?.isActive : false,
            isKiosk: result.data?.isKiosk ? result.data?.isKiosk : false,
            autoRollover: result.data?.autoRollover
              ? result.data?.autoRollover
              : false,
            serviceType: result.data?.packageRideType ? reverseServiceTypeMap[result.data.packageRideType] : "",
            isAirportExpress: corporateClientField?.value?.id
              ? (corporateClientField?.value?.isAirportClient ? false : true)
              : result.data?.isAirportExpress,
            city: result.data?.serviceCityId
              ? { id: serviceCity.value.id, name: serviceCity.value.name }
              : "",
            carTypeDropdown: result.data?.carTypeId
              ? { id: result.data?.carTypeId }
              : "",
            baseFareTax: result.data?.baseFareTaxId
              ? {
                  taxGroupId: result.data?.baseFareTaxId,
                  name: result.data?.baseFareTaxName,
                }
              : "",
            serviceTax: result.data?.serviceTaxId
              ? {
                  taxGroupId: result.data?.serviceTaxId,
                  name: result.data?.serviceTaxName,
                }
              : "",
            corporateClient: result.data?.corporateClientId
              ? {
                  id: result.data?.corporateClientId,
                  name: result.data?.corporateClientName,
                }
              : null,
            thirdPartyClientId: result.data?.thirdPartyClientId
              ? result.data?.thirdPartyClientId
              : null,
            isAirportBooking: result.data?.isAirportBooking
              ? result.data?.isAirportBooking
              : false,
            applicableFromDate: result.data?.applicableFromDate
              ? new Date(result.data?.applicableFromDate)
              : "",
            applicableToDate: result.data?.applicableToDate
              ? new Date(result.data?.applicableToDate)
              : "",
            isDriverPayout: result.data?.isDriverPayout
              ? result.data?.isDriverPayout
              : false,
            initialDistanceKm: result.data?.initialDistanceKm
              ? result.data?.initialDistanceKm
              : null,
            perKmCharge: result.data.perKmCharge
              ? result.data.perKmCharge
              : null,
            initialDistanceCharge: result.data.initialDistanceCharge
              ? result.data.initialDistanceCharge
              : null,
            tollAmount: result.data.tollAmount ? result.data.tollAmount : null,
            terminal: result.data?.terminal
              ? setterminal(result.data.terminal)
              : null,
          });
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  }, [editId, isOpen]);

  const setterminal = (data) => ({
    value: data,
    label: data,
  });
  useEffect(() => {
    // if packages is selected and client is not there for this package then apply the tax which is there in the package
    if (packageObj && packageObj.baseFareTaxId && packageObj.serviceTaxId && !corporateClientField?.value?.id) {
      const matchedTax = combinedTax.find(
        (item) =>
          item.value.baseTax.taxGroupId === packageObj.baseFareTaxId &&
          item.value.serviceTax.taxGroupId === packageObj.serviceTaxId
      );
      setValue("overallTax", matchedTax);
      setValue("baseFareTax", matchedTax?.value.baseTax);
      setValue("serviceTax", matchedTax?.value.serviceTax);
    } else {
      // No corporate client → reset to placeholder
      setValue("overallTax", null);
    }
  }, [packageObj, combinedTax, setValue, isOpen]);

  function findOption(baseTaxId, serviceTaxId) {
    console.log("base and service id ", baseTaxId, serviceTaxId);
    return combinedTax.find((item) => {
      return (
        item.value.baseTax.id === baseTaxId &&
        item.value.serviceTax.id === serviceTaxId
      );
    });
  }

  const handleSelectTaxOption = (baseTax, serviceTax, combinedTax) => {
    combinedTax.find((taxOption) => {
      console.log("map startted");
      return (
        taxOption.baseTax.id === baseTax.id &&
        taxOption.serviceTax.id === serviceTax.id
      );
    });
  };

  const searchThirdparty = async (inputValue) => {
    console.log("input value :", inputValue);
    if (inputValue) {
      let obj = {
        key: inputValue,
        // serviceCityId:cityField?.value.id
      };
      return fetchThirdParty(obj).then((resp) => {
        console.log("response from thirdParty", resp.data.list);
        if (resp.data) {
          console.log("response list ", resp.data.list);
          let data = resp.data.list.map((element) => {
            return {
              value: element,
              label: element.companyName,
            };
          });
          return data;
        }
        return [];
      });
    }
  };

  const fetchThirdParty = async (obj) => {
    const config = {
      headers: {
        token: localStorage.getItem("token"),
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios
        .post(
          tmsApi + `v1/entities/corporateclient/thirdparty/search/${obj.key}`,
          config
        )
        .then((resp) => {
          console.log("result data is ", resp.data.list);
          return resp;
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (corporateClientField?.value?.id) {
      getCorporateClient(corporateClientField?.value?.id)
        .then((resp) => {
          console.log('fetched the client data:',resp.data)
          setParentCorpClient(resp.data);
          const matchedTax = combinedTax.find(
        (item) =>
          item.value.baseTax.taxGroupId === resp.data.baseFareTaxId &&
          item.value.serviceTax.taxGroupId === resp.data.serviceTaxId
          );
          console.log('matched tax',matchedTax)
          setValue("overallTax", matchedTax);
          setValue("baseFareTax", matchedTax?.value.baseTax);
          setValue("serviceTax", matchedTax?.value.serviceTax);
        })
        .catch((err) => {
          showAlert("Can't able to fetch CorporateClient");
        })
      
      const matchedTax = combinedTax.find(
        (item) =>
          item.value.baseTax.taxGroupId === packageObj.baseFareTaxId &&
          item.value.serviceTax.taxGroupId === packageObj.serviceTaxId
      );
    }

  }, [corporateClientField?.value?.id, isOpen]);

  const serviceTypeOptions = [
    { value: "ALL", label: "All" },
    { value: "A2C", label: "Airport To City" },
    { value: "C2A", label: "City To Airport" },
    { value: "C2C", label: "City To City" },
  ];

  const serviceTypeMap = {
    A2C: "AirportToCity",
    C2A: "CityToAirport",
    C2C: "CityToCity",
    ALL: "All",
  };

  const reverseServiceTypeMap = {
    AirportToCity: "A2C",
    CityToAirport: "C2A",
    CityToCity: "C2C",
    All: "ALL",
  };

  const serviceTypeField = useController({
    name: "serviceType",
    control,
    rules: {
      required: {
        value: true,
        message: "Service Type is Required",
      },
    },
  }).field;

  const handleServiceTypeChange = (data) => {
    serviceTypeField.onChange(data.value);
  };

  const onFormSubmit = (formValues) => {
    setIsSubmitting(true);
    console.log("form values", formValues);
    const isAirportExpress = formValues.serviceType === "C2A" || 
                        formValues.serviceType === "C2C" || 
                        formValues.serviceType === "All";
    const body = {
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
      isKiosk: formValues.isKiosk,
      autoRollover: formValues.autoRollover,
      isAirportExpress: isAirportExpress,
      packageRideType: serviceTypeMap[formValues.serviceType],
      isAirportBooking: formValues.isAirportBooking,
      serviceCityId: formValues.city.id,
      // serviceCityId: corpsPresent ? corprateClient.serviceCityId :formValues.city.id,
      serviceCityName: formValues.city.name,
      baseFareTaxId: formValues.baseFareTax.taxGroupId,
      baseFareTaxName: formValues.baseFareTax.taxCategory,
      serviceTaxId: formValues.serviceTax.taxGroupId,
      serviceTaxName: formValues.serviceTax.taxCategory,
      corporateClientId: formValues.corporateClient?.id
        ? formValues.corporateClient.id
        : null,
      thirdPartyClientId: formValues.corporateClient.id
        ? formValues.corporateClient.id
        : null,

      corporateClientName: formValues.corporateClient?.companyName
        ? formValues.corporateClient.companyName
        : null,

      // corporateClientId: formValues.corprateClient? corprateClient.id :formValues.corporateClient.id,
      applicableFromDate: new Date(formValues.applicableFromDate),
      applicableToDate: new Date(formValues.applicableToDate),
      carTypeId: formValues.carTypeDropdown.id,
      isDriverPayout: formValues.isDriverPayout
        ? formValues.isDriverPayout
        : false,
      initialDistanceKm: formValues.initialDistanceKm
        ? formValues.initialDistanceKm
        : null,
      perKmCharge: formValues.perKmCharge ? formValues.perKmCharge : null,
      initialDistanceCharge: formValues.initialDistanceCharge
        ? formValues.initialDistanceCharge
        : null,
      tollAmount: formValues.tollAmount ? formValues.tollAmount : null,
      terminal: formValues.city.id != 1 || isAirportExpress ? null : formValues?.terminal ? formValues.terminal.value : "",
    };
    createPackage(body)
      .then((result) => {
        console.log("created package", result.data);
        reset({
          name: "",
          description: "",
          isActive: false,
          isKiosk: false,
          autoRollover: false,
          isAirportExpress: false,
          city: "",
          carTypeDropdown: "",
          baseFareTax: "",
          serviceTax: "",
          corporateClient: "",
          isAirportBooking: false,
          applicableFromDate: "",
          applicableToDate: "",
        });
        showAlert("success", "Package Created Successfully");
        setIsSubmitting(false);
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
        setIsSubmitting(false);
      });
  };

  const onEditSubmit = (formValues) => {
    console.log("edit values", formValues);
    setIsSubmitting(true);
    const isAirportExpress = formValues.serviceType === "C2A" || 
                        formValues.serviceType === "C2C" || 
                        formValues.serviceType === "All";
    const body = {
      id: packageObj?.id,
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
      isKiosk: formValues.isKiosk,
      autoRollover: formValues.autoRollover,
      isAirportExpress: isAirportExpress,
      packageRideType: serviceTypeMap[formValues.serviceType],
      isAirportBooking: formValues.isAirportBooking,
      serviceCityId: formValues.city.id,
      serviceCityName: formValues.city.name,
      baseFareTaxId: formValues.baseFareTax.taxGroupId,
      baseFareTaxName: formValues.baseFareTax.taxCategory,
      serviceTaxId: formValues.serviceTax.taxGroupId,
      serviceTaxName: formValues.serviceTax.taxCategory,
      corporateClientId: formValues.corporateClient?.id
        ? formValues.corporateClient.id
        : null,
      applicableFromDate: new Date(formValues.applicableFromDate),
      applicableToDate: new Date(formValues.applicableToDate),
      carTypeId: formValues.carTypeDropdown.id,
      isDriverPayout: formValues.isDriverPayout
        ? formValues.isDriverPayout
        : false,
      initialDistanceKm: formValues.initialDistanceKm
        ? formValues.initialDistanceKm
        : null,
      perKmCharge: formValues.perKmCharge ? formValues.perKmCharge : null,
      initialDistanceCharge: formValues.initialDistanceCharge
        ? formValues.initialDistanceCharge
        : null,
      tollAmount: formValues.tollAmount ? formValues.tollAmount : null,
      thirdPartyClientId: formValues.thirdPartyClientId
        ? formValues.thirdPartyClientId
        : null,
      terminal: formValues.city.id != 1 ? null : formValues?.terminal ? formValues.terminal.value : "",
    };
    editPackageDetails(body)
      .then((result) => {
        reset({
          name: "",
          description: "",
          isActive: false,
          isKiosk: false,
          autoRollover: false,
          isAirportExpress: false,
          city: "",
          carTypeDropdown: "",
          baseFareTax: "",
          serviceTax: "",
          corporateClient: "",
          isAirportBooking: false,
          applicableFromDate: "",
          applicableToDate: "",
          terminal:""
        });
        showAlert("success", "Package Updated Successfully");
        setPackageObj({});
        setIsSubmitting(false);
        setIsOpen(false);
        fetchTableData();
      })
      .catch((err) => {
        console.log('error occured:',err)
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
        setIsSubmitting(false);
      });
  };

  const getPackageOptions = async (inputValue) => {
    if (inputValue.length) {
      console.log(inputValue);
      let obj = {
        name: inputValue,
      };
      return getPackagesListBySearch(obj).then((result) => {
        const mappedArray = result.data.list.map((item) => ({
          value: item,
          label: item.name,
        }));

        return mappedArray;
      });
    }
  };

  const handleBaseFareTax = (data) => {
    baseFareTaxField.onChange(data.value);
  };

  const serviceTaxField = useController({
    name: "serviceTax",
    control,
    // rules: {
    //     required: {
    //         value: true,
    //         message: "Service Tax is Required",
    //     },
    // },
  }).field;

  const handleServiceFareTax = (data) => {
    serviceTaxField.onChange(data.value);
  };

  const corprateField = useController({
    name: "corprateField",
    control,
    rules: {
      required: {
        value: false,
        message: "corprateClient is Required",
      },
    },
  }).field;

  const airportField = useController({
      name: "terminal",
      control,
      rules: {
        validate: (value) => {
          // Only required if cityField id is 1
          if (cityField?.value?.id === 1 && serviceTypeField?.value === "A2C" && !value) {
            return "Terminal is required for this city";
          }
          return true; // valid in all other cases
        },
      },
    }).field;
  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={() => setIsOpen()}
        PaperProps={{
          sx: {
            width: "40vw",
            borderTopLeftRadius: "1.49vw",
            borderBottomLeftRadius: "1.49vw",
          },
        }}
        sx={{
          "& .MuiDrawer-paper": {
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE & Edge
            "&::-webkit-scrollbar": {
              display: "none", // Chrome, Safari
            },
          },
        }}
      >
        <Box sx={{ flex: "1" }}>
          <Box
            sx={{
              flex: 1,
              backgroundColor: "rgba(244, 247, 253, 1)",
              height: "3vw",
            }}
          >
            <Box
              sx={{
                paddingTop: "1vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "40%",
                gap: "1vw",
              }}
            >
              <img
                src={closeIcon}
                alt={"close"}
                style={{ width: "1.79vw", height: "1.79vw", cursor: "pointer" }}
                onClick={() => setIsOpen(!isOpen)}
              />
              <Box
                sx={{
                  width: "0.78vw",
                  height: "0.78vw",
                  background: "rgba(57, 181, 74, 1)",
                  borderRadius: "30%",
                }}
              />
              <Typography
                sx={{
                  color: "rgba(57, 181, 74, 1)",
                  fontSize: "1.11vw",
                  fontWeight: "600",
                }}
              >
                {title}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              marginX: "1.04vw",
              marginTop: "0.69vw",
              paddingX: "0.69vw",
            }}
          >
            <Form
              onSubmit={handleSubmit(
                packageObj?.id ? onEditSubmit : onFormSubmit
              )}
            >
              <Row
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">Name</Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      {...register("name", {
                        required: {
                          value: true,
                          message: "Name is required",
                        },
                        onChange: (e) => {
                          setValue("name", e.target.value.trimStart());
                        },
                      })}
                    />

                    <span style={{ color: "red" }}>
                      {errors?.name?.message}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Service City
                  </Label>
                  <Col lg="12">
                    <div className="city-select">
                      {/* {corpsPresent ?
                        <input
                            className="form-control"
                            type="text"
                            {...register("servicity", {
                                required: {
                                    value: true,
                                    message: "Name is required",
                                },
                                onChange: (e) => {
                                    setValue("name", e.target.value.trimStart())
                                }
                            })}
                        />
                    : */}
                      {/* <CustomSelect 
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={cityField?.value?.id ? cityData.find((element) => {
                            return element?.id === corprateClient?corprateClient.serviceCityId: cityField?.value?.id;
                        }) : ""}
                        // value={ cityData.find((element) => {
                        //          return element?.id === corprateClient?corprateClient.serviceCityId:cityField?.value?.id})}
                        isDisabled={packageObj?.id ? true : false}
                        // value={corpsPresent ? 
                        //     cityData.find((element) => {
                        //         return element?.value?.id === corprateClient.serviceCityId;
                        //     }) : 
                        //     cityData.find((element) => {
                        //         return element?.value?.id === cityData?.value?.id;
                        //     })}
                        
                        // value={cityData.find(4)}
                        // isDisabled={packageObj?.id ? true : false}
                        // defaultValue={cityData.find((element) => {
                        //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                        //   return element?.value?.id === cityField?.value?.id;
                        // })}
                        onChange={handleCitySelectChange}
                        placeholder="Select City"
                        options={corprateClient?serviceCity:cityData}
                    /> */}
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={
                          cityField?.value?.id
                            ? cityData.find((element) => {
                                return (
                                  element?.value?.id === cityField?.value?.id
                                );
                              })
                            : ""
                        }
                        isDisabled={corporateClientField?.value?.id ? true : false}
                        // defaultValue={cityData.find((element) => {
                        //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                        //   return element?.value?.id === cityField?.value?.id;
                        // })}
                        onChange={handleCitySelectChange}
                        placeholder="Select City"
                        options={cityData}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {errors?.city?.message}
                    </span>
                  </Col>
                </FormGroup>
              </Row>
                <Row style={{ display: "flex", justifyContent: "flex-start" }}>
                {corporateClientField?.value?.id && (
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Corporate Client
                  </Label>
                  <Col lg="12">
                    <div className="city-select">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={
                          corporateClientField?.value?.id
                            ? corporateClientData.find((element) => {
                                return (
                                  element?.value?.id ===
                                  corporateClientField?.value?.id
                                );
                              })
                            : ""
                        }
                        isDisabled={cityField?.value?.id ? false : true}
                        // defaultValue={cityData.find((element) => {
                        //     return element?.value?.id === cityField?.value?.id;
                        // })}
                        onChange={handleCorporateClientSelectChange}
                        placeholder={
                          cityField?.value?.id
                            ? "Select Corporate Client"
                            : "Select city to select corporate client"
                        }
                        options={corporateClientData}
                      />
                    </div>

                    <span style={{ color: "red" }}>
                      {errors ? corporateClientField?.message : null}
                    </span>
                  </Col>
                </FormGroup>
                )}
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">Car Type</Label>
                  <Col lg="12">
                    <div className="city-select">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={
                          carTypeField?.value?.id
                            ? carTypeData.find((element) => {
                                return (
                                  element?.value?.id === carTypeField?.value?.id
                                );
                              })
                            : ""
                        }
                        isDisabled={cityField?.value?.id ? false : true}
                        onChange={handleCarTypeSelectChange}
                        placeholder={
                          cityField?.value?.id
                            ? "Select Car Type"
                            : "Select city to select car type"
                        }
                        options={carTypeData}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {errors?.carTypeDropdown?.message}
                    </span>
                  </Col>
                </FormGroup>
                {!corporateClientField?.value?.id && (
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">Tax</Label>
                    <Col lg="12">
                      <div className="city-select">
                        <Select
                          value={overallTax}
                          {...register("overallTax")}
                          onChange={(e) => {
                            setValue("overallTax", e);
                            setValue("baseFareTax", e.value.baseTax);
                            setValue("serviceTax", e.value.serviceTax);
                          }}
                          placeholder={"Select Tax"}
                          options={combinedTax}
                        />
                      </div>
                      <span style={{ color: "red" }}>
                        {errors?.combinedOpt?.message}
                      </span>
                    </Col>
                  </FormGroup>
                )}
                {/* {!corporateClientField?.value?.id && ( */}
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Service Type
                    </Label>
                    <Col lg="12">
                      <div className="city-select">
                        <CustomSelect
                          className="service-select"
                          classNamePrefix="select"
                          isClearable={false}
                          isSearchable={false}
                          value={serviceTypeOptions.find(
                            (item) => item.value === serviceTypeField.value
                          )}
                          onChange={(selected) => {
                            handleServiceTypeChange(selected);
                          }}
                          placeholder="Select Service Type"
                          options={serviceTypeOptions}
                        />
                      </div>
                    </Col>
                  </FormGroup>
                 {/* )} */}
              {cityField?.value?.id === 1 && serviceTypeField?.value === "A2C" && (
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">Terminal</Label>
                    <Col lg="12">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={true} // optional: search in terminals
                        value={
                          terminals.find(
                            (option) =>
                              option.value === getValues("terminal")?.value
                          ) || null
                        }
                        isDisabled={
                          editId ? false : packageObj?.id ? true : false
                        }
                        onChange={(selectedOption) =>
                          handleTerminalSelectChange(selectedOption)
                        }
                        placeholder="Select Terminal"
                        options={terminals}
                        getOptionLabel={(option) => option.label}
                      />

                      {errors?.terminal && (
                        <span style={{ color: "red" }}>
                          {errors.terminal.message}
                        </span>
                      )}
                    </Col>
                  </FormGroup>
              )}
              </Row>           
              <Row style={{ display: "flex", justifyContent: "space-around" }}>
                {/* <FormGroup
                  className="col-lg-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className={
                      mix_background_layout == "dark-only"
                        ? "checkbox-dark p-0"
                        : "checkbox p-0"
                    }
                  >
                    <Input
                      id="AirportExpress"
                      type="checkbox"
                      checked={isAirportExpressField.value}
                      onChange={(value) =>
                        isAirportExpressField.onChange(value)
                      }
                    />
                    <Label className="mb-0" for="AirportExpress">
                      City To Airport
                    </Label>
                  </div>
                  
                </FormGroup> */}
                <FormGroup
                  className="col-lg-6"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className={
                      mix_background_layout == "dark-only"
                        ? "checkbox-dark p-0"
                        : "checkbox p-0"
                    }
                  >
                    <Input
                      id="IsActive"
                      type="checkbox"
                      checked={isActiveField.value}
                      onChange={(value) => isActiveField.onChange(value)}
                    />
                    <Label className="mb-0" for="IsActive">
                      {"Available {Yes/No}"}
                    </Label>
                  </div>
                </FormGroup>

                <FormGroup
                  className="col-lg-6"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className={
                      mix_background_layout == "dark-only"
                        ? "checkbox-dark p-0"
                        : "checkbox p-0"
                    }
                  >
                    <Input
                      id="IsKiosk"
                      type="checkbox"
                      checked={isKioskField.value}
                      onChange={(value) => isKioskField.onChange(value)}
                    />
                    <Label className="mb-0" for="IsKiosk">
                      {"Enable for Kiosk"}
                    </Label>
                  </div>
                </FormGroup>
                {/* <FormGroup
                  className="col-lg-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    className={
                      mix_background_layout == "dark-only"
                        ? "checkbox-dark p-0"
                        : "checkbox p-0"
                    }
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <input
                      style={{
                        width: "1.5rem",
                        height: "1.5rem",
                      }}
                      id="isDriverPayout"
                      type="checkbox"
                      {...register("isDriverPayout", {})}
                    />
                    <Label className="mb-0" for="isDriverPayout">
                      {"IsDriverPayout"}
                    </Label>
                  </div>
                </FormGroup> */}
              </Row>
              {/* {isDriverPayout ? (
                <>
                <Row style={{ display: "flex", justifyContent: "center" }}>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      InitialDistanceKm
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("initialDistanceKm", {
                          required: {
                            value: isDriverPayout,
                            message: "InitialDistanceKm is required",
                          },
                          onChange: (e) => {
                            setValue(
                              "initialDistanceKm",
                              e.target.value.trimStart()
                            );
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.initialDistanceKm?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      InitialDistanceCharge
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("initialDistanceCharge", {
                          required: {
                            value: isDriverPayout,
                            message: "InitialDistanceCharge is required",
                          },
                          onChange: (e) => {
                            setValue(
                              "initialDistanceCharge",
                              e.target.value.trimStart()
                            );
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.initialDistanceCharge?.message}
                      </span>
                    </Col>
                  </FormGroup>
                </Row>
                <Row>
                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      PerKmCharge
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        key={false}
                        {...register("perKmCharge", {
                          required: {
                            value: isDriverPayout,
                            message: "perKmCharge is required",
                          },
                          onChange: (e) => {
                            setValue("perKmCharge", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.perKmCharge?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">
                      Toll Amount
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="number"
                        key={false}
                        {...register("tollAmount", {
                          required: {
                            value: isDriverPayout,
                            message: "TollAmount is required",
                          },
                          onChange: (e) => {
                            setValue("tollAmount", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.tollAmount?.message}
                      </span>
                    </Col>
                  </FormGroup>
                  </Row>
                  </>
              ) : null} */}

              <Row style={{ display: "flex", justifyContent: "center" }}>
                <div
                  style={{
                    color: "#11BF5C",
                    textDecoration: "underline",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsAdvanced(!isAdvanced)}
                >
                  Advanced Configurations{" "}
                  {isAdvanced ? (
                    <ArrowUp
                      style={{
                        width: "15px",
                        height: "15px",
                        marginLeft: "5px",
                      }}
                    />
                  ) : (
                    <ArrowDown
                      style={{
                        width: "15px",
                        height: "15px",
                        marginLeft: "5px",
                      }}
                    />
                  )}
                </div>
              </Row>

              {isAdvanced ? (
                <>
                  <Row
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <FormGroup className="col-lg-6">
                      <Label className="col-lg-12 col-form-label">
                        Description
                      </Label>
                      <Col lg="12">
                        <input
                          className="form-control"
                          type="text"
                          {...register("description", {
                            onChange: (e) => {
                              setValue(
                                "description",
                                e.target.value.trimStart()
                              );
                            },
                          })}
                        />
                        <span style={{ color: "red" }}>
                          {errors?.description?.message}
                        </span>
                      </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-6">
                      <Label className="col-lg-12 col-form-label">
                        Available From
                      </Label>
                      <Col lg="12">
                        <InputGroup
                          className="date"
                          id="dt-minimum"
                          data-target-input="nearest"
                        >
                          <DatePicker
                            className="form-control datetimepicker-input digits"
                            selected={applicableFromDateField.value}
                            showTimeInput
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            onChange={handleApplicableFromDate}
                            dateFormat="MMMM d yyyy, h:mm:ss a"
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                          />
                        </InputGroup>
                        <span style={{ color: "red" }}>
                          {errors?.applicableFromDate?.message}
                        </span>
                      </Col>
                    </FormGroup>
                  </Row>
                  <Row>
                    <FormGroup className="col-lg-6">
                      <Label className="col-lg-12 col-form-label">
                        Available To
                      </Label>
                      <Col lg="12">
                        <InputGroup
                          className="date"
                          id="dt-minimum"
                          data-target-input="nearest"
                        >
                          <DatePicker
                            className="form-control datetimepicker-input digits"
                            selected={applicableToDateField.value}
                            showTimeInput
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            onChange={handleApplicableToDate}
                            dateFormat="MMMM d yyyy, h:mm:ss a"
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                          />
                        </InputGroup>
                        <span style={{ color: "red" }}>
                          {errors?.applicableToDate?.message}
                        </span>
                      </Col>
                    </FormGroup>
                  </Row>
                </>
              ) : null}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "2vw",
                }}
              >
                <button
                  type="submit"
                  className="btn submit-button"
                  disabled={isSubmitting}
                >
                  {"Update"}
                </button>
              </div>
            </Form>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export default CreateEditPackageDrawerForm;
